// export const environment = {
//   production: true,
//   paymentApiUrl: 'https://api.zionn.space/superuserapi', 
//   apiUrl: 'http://localhost:8080/api',
//   urlHub: 'http://localhost:8080',
//   featureFlag: false,
//   googleAnalyticsKey: 'G-JPKHHHNY4V'
//   // confirmationMailUrl:'https://lmn8n.zionn.space/webhook/confirmation-link',
//   // n8nLink : 'https://lmn8n.zionn.space/webhook'
// };
export const environment = {
  production: true,
  apiUrl: 'https://api.zionn.space/api',
  urlHub: 'https://api.zionn.space',
  paymentApiUrl: 'https://api.zionn.space/superuserapi', 
  // paymentApiUrl: 'http://localhost:8080/superuserapi', 
  featureFlag: false,
  googleAnalyticsKey: 'G-JPKHHHNY4V',
  confirmationMailUrl:'https://lmn8n.zionn.space/webhook/confirmation-link',
  n8nLink : 'https://lmn8n.zionn.space/webhook'
};
